import React, { useState, useEffect } from "react";
import styled from "styled-components";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import SideBar from "./SideBar";
import { FaArrowLeft } from "react-icons/fa";

import HeaderName from "./HeaderName";
import { useSelector } from "react-redux";
import PurchaseDialog from "./Admin/Purchase/purchasePriceUpdateDialog";
const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 10px;
  border: none;
  border-radius: 10px;
`;
const DisableButton = styled.button`
  background: rgb(167, 169, 182);
  color: white;
  justify-content: center;
  padding: 5px 10px;
  border: none;
  border-radius: 10px;
`;

const Create = () => {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  // const url = 'http://localhost:9000/api/'
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const navigate = useNavigate();
  const [fromUnit, setFromUnit] = useState(1);
  const [toUnit, setToUnit] = useState("");
  const [bankList, setBankList] = useState([]);
  const [cashList, setCashList] = useState([]);
  const [purchasePrice, setPurchasePrice] = useState("");
  const [changePurPrice, setChangePurPrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [subQty, setSubQty] = useState(0);
  const [subPrice, setSubPrice] = useState(0);
  const [showBank, setShowBank] = useState(false);
  const [showCash, setShowCash] = useState(false);
  const [supplierCode, setSupplierCode] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [delID, setDelID] = useState("");
  const [units, setUnits] = useState([]);
  const [qty, setQty] = useState(0);
  const [relatedUnitID, setRelatedUnitID] = useState("");
  const [type, setType] = useState("");
  const [medicines, setMedicines] = useState([]);
  const [unitConventionLists, setUnitConventionLists] = useState([]);
  const [medicineLists, setMedicineLists] = useState([]);
  const [emptyRes, setEmptyRes] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [value, setValue] = useState("");
  const [id, setId] = useState("");
  const [relatedUnitConvention, setRelatedUnitConvention] = useState("");
  const [date, setDate] = useState("");
  const [reqDate, setReqDate] = useState("");
  const [remark, setRemark] = useState("");
  const [reason, setReason] = useState("");
  const [expDate, setExpDate] = useState("");
  const [alertDate, setAlertDate] = useState("");
  const [totqty, setTotQty] = useState(0);
  const [totprice, setTotPrice] = useState(0);
  const [branchLists, setBranchLists] = useState([]);
  const [branch, setBranch] = useState("");
  const [medicineSale, setMedicineSale] = useState([]);
  const [totalUnit, setTotalUnit] = useState("");
  const [initialAmount, setInitialAmount] = useState("");
  const [unit, setUnit] = useState("");
  const [code, setCode] = useState("");
  const [seq, setSeq] = useState("");
  const [relatedFromUnitName, setRelatedFromUnitName] = useState("");
  const [relatedToUnitName, setRelatedToUnitName] = useState("");
  const [supplierList, setSupplierList] = useState([]);
  const [relatedSupplier, setRelatedSupplier] = useState("");
  const [originalPrice, setOriginalPrice] = useState(0);
  const handleCashRadioChange = () => {
    setShowBank(false);
    setShowCash(true);
  };
  const handleUnitCalculation = (event) => {
    if (qty) {
      let multi = qty * event;
      let ans = multi / (fromUnit || 0);

      setTotalUnit(ans.toFixed(2));
    }

    setToUnit(event);
  };

  const handleTotalUnit = (e) => {
    if (type === "Direct") {
      if (e) {
        let multi = e * 1;
        let ans = multi / 1;

        setTotalUnit(ans.toFixed(2));
      }
    } else {
      // setQty(e);
      if (e) {
        let multi = e * toUnit;
        let ans = multi / fromUnit;

        setTotalUnit(ans.toFixed(2));
      }
    }
  };
  useEffect(() => {
    const getBankLists = async () => {
      try {
        const res = await api.get("accounting-lists");

        const bank = res.data.list.filter(
          (el) =>
            el.relatedHeader.name == "Cash At Bank" &&
            el.relatedType.name === "Assets"
        );
        setBankList(bank);
      } catch (err) {}
    };
    const getAccountingLists = async () => {
      try {
        const res = await api.get("accounting-lists");
        const medicineSale = res.data.list.filter(
          (e) =>
            e.relatedHeader.name == "Adminstrative exp" &&
            "Selling and distribution expense" &&
            "Personal expense" &&
            e.relatedType.name == "Profit and Loss"
        );
        setInitialAmount(medicineSale[0].amount);
        // setFinalAmount(medicineSale[0].amount);
        setMedicineSale(medicineSale);
        // setAccountingList(res.data.list);
        // set(
        //   res.data.list.filter((e) => e.relatedHeader.name == "Current Assets")
        // );
      } catch (err) {}
    };

    const getBanks = async () => {
      try {
        const res = await api.get("suppliers");
        setSuppliers(res.data.list);
        console.log("supp");
        console.log(suppliers);
      } catch (err) {}
    };
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    const getCashLists = async () => {
      try {
        const res = await api.get("accounting-lists");

        const cash = res.data.list.filter(
          (el) =>
            el.relatedHeader.name == "Cash In Hand" &&
            el.relatedType.name === "Assets"
        );
        setCashList(cash);
      } catch (err) {}
    };

    const getCode = async () => {
      try {
        const res = await api.get("purchase-requests/code");
        setCode(res.data.data.code);
        setSeq(res.data.data.seq);
        // console.log(res.data.data, 'list')
      } catch (err) {
        alert(err.message);
      }
    };
    const getUnitLists = async () => {
      try {
        const res = await api.get("unit-convention");

        // setUnitLists(res.data.list.filter((el)=>el.name._id == medicineListId))
        const filtered = res.data.data.filter(
          (el) => el.relatedItem?._id === id
        );
        setUnitConventionLists(filtered);
        console.log(filtered, "u");
      } catch (err) {}
    };
    const getMedicineLists = async () => {
      try {
        const res = await api.get("medicine-lists");

        setMedicineLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    const getSupplier = async () => {
      try {
        const res = await api.get("suppliers");

        setSupplierList(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    getSupplier();
    getMedicineLists();
    getCode();
    getUnitLists();
    getCashLists();
    getBankLists();
    getBranches();
    getAccountingLists();
    getBanks();
  }, [qty, toUnit, id]);

  const chgItem = (val) => {
    console.log(val, "val");
    getMedicines(val);
  };
  const handleToUnit = (id) => {
    // console.log(id, "u");
    setRelatedUnitConvention(id);

    const res = unitConventionLists.filter((el) => el._id === id)[0];
    setRelatedToUnitName(res?.relatedToUnit?._id);
    // console.log(res, "res");
    setOriginalPrice(res?.relatedFromUnit?.purchasePrice);
    setPurchasePrice(res?.relatedFromUnit?.purchasePrice);
    setSellingPrice(res?.relatedFromUnit?.sellingPrice);
    setFromUnit(res.fromUnit);
    setToUnit(res.toUnit);
    console.log(res.toUnit);
    handleUnitCalculation(res.toUnit);
  };
  const chgPrice = (val) => {
    // console.log(val, "r id");
    setRelatedUnitID(val);

    const res = unit[0] && unit.filter((el) => el._id === val)[0];
    // console.log(res, "r");
    setOriginalPrice(res?.purchasePrice);
    setPurchasePrice(res?.purchasePrice);
    setSellingPrice(res?.sellingPrice);
    // setPurchasePrice(res);
  };
  const getMedicines = async (id) => {
    const res = await api.get("medicine-items");
    // console.log('bro!');
    console.log(id, "med");
    setUnits(res.data.list.filter((el) => el.name?._id === id));
    console.log(
      res.data.list.filter((el) => el.name?._id === id),
      "med"
    );
    setValue(1);
  };

  const chgQty = async (val) => {
    const res = units.filter((el) => el._id == val);
    console.log("hi", res);
    console.log(res[0], "chg aty");

    setUnit(res[0]?.relatedItemUnits);

    setId(val);
  };

  const addPurchase = async () => {
    const res = units.filter((el) => el._id === id);
    setEmptyRes(res);
    console.log(branch, "b");
    const obj = {
      item_id: id,

      name: res[0] ? res[0].medicineItemName : "",
      stockQty: qty,
      requestedQty: parseInt(qty),
      recievedQty: 0,
      purchasePrice: purchasePrice,
      subTotal: parseInt(purchasePrice) * qty,
      expiredDate: expDate,
      alertDate: alertDate,
      sellingPrice: unit[0].sellingPrice,
      unitType: type,
    };
    // if (branch === "HO") {
    // } else {
    //   obj.relatedBranch = branch;
    // }
    if (type === "Convert") {
      obj.relatedUnitConvention = relatedUnitConvention;
      obj.relatedToUnitName = relatedToUnitName;
      obj.relatedFromUnitName = relatedFromUnitName;
      obj.totalUnit = parseInt(totalUnit);
      obj.fromUnit = fromUnit || 1;
      obj.toUnit = toUnit || 1;
    } else {
      obj.relatedItemUnit = unit[0]._id;
      obj.totalUnit = parseInt(qty) * 1;
      obj.fromUnit = 1;
      obj.toUnit = 1;
    }
    // if (purchasePrice) {
    //   obj.purchasePrice = purchasePrice
    //   obj.sellingPrice = sellingPrice
    //   obj.subTotal = purchasePrice * qty
    // }
    // else {
    //   obj.sellingPrice = res[0]?.sellingPrice
    //   obj.subTotal = res[0]?.purchasePrice * qty
    //   obj.purchasePrice = res[0]?.purchasePrice
    // }

    setMedicines((arr) => [...arr, obj]);

    if (purchasePrice) {
      setTotPrice(totprice + purchasePrice * qty);
      setTotQty(totqty + parseInt(qty));
    } else {
      setTotPrice(totprice + res[0]?.purchasePrice * qty);
      setTotQty(totqty + parseInt(qty));
    }
    if (subQty || subPrice) {
      setSubPrice(subPrice + changePurPrice * qty);
      setSubQty(subQty + parseInt(qty));
    } else {
      setSubPrice(subPrice + changePurPrice * qty);
      setSubQty(subQty + parseInt(qty));
    }
  };
  console.log(medicines, "obj");
  const del = (index) => {
    setDelID(index);
    setMedicines(medicines.filter((val, i) => i !== index));
    // console.log(
    //   medicines.filter((val, i) => i !== index),
    //   "m"
    // );
    //for remove that you choose index items
    const remove = medicines.splice(index);

    console.log(remove[0], "r u");
    setTotQty(totqty - parseInt(remove[0]?.stockQty));
    setTotPrice(
      totprice -
        parseInt(remove[0]?.purchasePrice) * parseInt(remove[0]?.stockQty)
    );
  };

  const handleBranchError = () => {
    Swal.fire({
      title: "Please Choose Branch",
      // text: 'You Created Purchase Request Data!',
      icon: "error",
      // showCancelButton: true,

      cancelButtonText: "Close",
    });
  };
  console.log(medicines, "medicines");
  const save = () => {
    const data = {
      purchaseDate: date,
      requiredDate: reqDate,
      reason: reason,
      remark: remark,
      relatedSupplier: relatedSupplier,
      // relatedBranch: branch,
      medicineItems: medicines.map((item) => ({
        ...item, // copy original fields
        ...(branch !== "HO" && { relatedBranch: branch }),
      })),
      totalQTY: totqty,
      totalPrice: totprice,
      supplierVoucher: supplierCode,
      supplierName: supplierName,
      code: code,
      seq: seq,
    };

    // if (relatedBankAcc) data.relatedBankAccount = relatedBankAcc
    // if (relatedCashAcc) data.relatedCashAccount = relatedCashAcc
    // alert(JSON.stringify(data))
    api.post("purchase-request", data).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "You Created Purchase Request Data!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });
      navigate(-1);
    });
  };

  const handlePriceChange = async () => {
    const data = {
      item_id: id,
      relatedItemUnitID: type === "Convert" ? relatedFromUnitName : unit[0]._id,
      purchasePrice: purchasePrice,
    };
    console.log(data, "data");
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    });

    if (result.isConfirmed) {
      // Handle confirmed action here
      api
        .put("unit-convert/price", data)
        .then(function (response) {
          Swal.fire({
            title: "Successful!",
            text: "Updated Price!",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .catch(function (err) {
          Swal.fire({
            title: "Something Wrong!",
            text: "Try again, Please.",
            icon: "warning",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    }
  };
  return (
    <div classNameName='App'>
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className='wrapper'>
        {/* <!-- Navbar --> */}
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <Link to='/purchase'>
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className='breadcrumb-item active'></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section class='content'>
            <div class='container-fluid'>
              <h5 className='font-weight-bold mt-3'>
                Purchase Request Create Form
              </h5>
              <div className='row mt-3'>
                <div className='col-9'>
                  <div className='card'>
                    <div className='card-body'>
                      <div className='p-2'>
                        {/* <div className='row'>
                          <div className='offset-4 col-2'>
                            <div className='form-check form-check-inline mt-2 '>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='bank_cash'
                                id='bank'
                                value='1'
                                onClick={handleBankRadioChange}
                              />
                              &nbsp;
                              <label
                                className='form-check-label text-success'
                                for='bank'
                              >
                                Bank
                              </label>
                            </div>
                          </div>
                          <div className='col-2'>
                            <div className='form-check form-check-inline mt-2 px-4'>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='bank_cash'
                                id='cash'
                                value='2'
                                onClick={handleCashRadioChange}
                              />
                              <label
                                className='form-check-label text-success'
                                for='cash'
                              >
                                Cash
                              </label>
                            </div>
                          </div>
                        </div> */}
                        <div className='row'>
                          <div className='col-6'>
                            <label htmlFor=''>Purchase Code</label>
                            <input
                              type='text'
                              className='form-control'
                              value={code}
                              // onChange={e => setDate(e.target.value)}
                            />
                          </div>

                          <div className='col-6'>
                            <label className={!branch && "text-red"}>
                              Branch
                            </label>
                            <select
                              name='currency'
                              id=''
                              className={
                                !branch
                                  ? "form-control mt-1 border border-danger"
                                  : "form-control mt-1 border border-info"
                              }
                              onchange='convert(this.value)'
                              // placeholder='Filter By Branches'
                              onChange={(e) => setBranch(e.target.value)}
                            >
                              <option hidden>Select Branch</option>
                              <option value='HO'>HO</option>

                              {branchLists.map((option) => (
                                <option value={option._id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className='row'>
                          <div className='col-6'>
                            <label htmlFor=''>Purchase Request Date</label>
                            <input
                              type='date'
                              className='form-control'
                              onChange={(e) => setDate(e.target.value)}
                            />
                          </div>
                          <div className='col-6'>
                            <label htmlFor=''>Required Date</label>
                            <input
                              type='date'
                              className='form-control'
                              onChange={(e) => setReqDate(e.target.value)}
                            />
                          </div>
                          <div className='row'>
                            <div className='col-6 mt-3'>
                              <label htmlFor=''>Reason</label>
                              <textarea
                                className='form-control'
                                onChange={(e) => setReason(e.target.value)}
                              />
                            </div>
                            <div className='col-6 mt-3'>
                              <label htmlFor=''>Remark</label>
                              <textarea
                                className='form-control'
                                onChange={(e) => setRemark(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className='row py-2'>
                            <label className={!relatedSupplier && "text-red"}>
                              Supplier
                            </label>
                            <select
                              name='currency'
                              id=''
                              className={
                                !relatedSupplier
                                  ? "form-control h-75 border border-danger"
                                  : "form-control h-75 border border-info"
                              }
                              onchange='convert(this.value)'
                              // placeholder='Filter By Branches'
                              onChange={(e) =>
                                setRelatedSupplier(e.target.value)
                              }
                            >
                              <option hidden>Select</option>

                              {supplierList.map((option) => (
                                <option value={option._id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                            {/* <div className='col-6 form-group'>
                            <label htmlFor=''>Supplier Code</label>
                            <input
                              type='text'
                              className='form-control'
                              onChange={(e) => setSupplierCode(e.target.value)}
                            />
                          </div>
                          <div className='col-6 form-group'>
                            <label htmlFor=''>Supplier Name</label>
                            <input
                              type='text'
                              className='form-control'
                              onChange={(e) => setSupplierName(e.target.value)}
                            />
                          </div> */}
                          </div>
                          <hr className='mt-3' />
                          <div className='offset-1 col-10 mt-3'>
                            <table className='table table-hover'>
                              <thead>
                                <tr>
                                  {/* <th>#</th> */}
                                  <th scope='col'>Name</th>
                                  <th scope='col'>Qty</th>
                                  <th scope='col'>Price</th>

                                  <th scope='col'>Sub Total</th>
                                  <th scope='col'>Expired Date</th>
                                  <th scope='col'>Alert Date</th>
                                  <th scope='col'>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {medicines.map((med, index) => (
                                  <tr>
                                    {/* <th>{++index}</th> */}
                                    <th>{med.name}</th>
                                    <th>{med.requestedQty}</th>
                                    <th>{med.purchasePrice}</th>
                                    <th>{med.subTotal}</th>
                                    <th>{med.expiredDate}</th>
                                    <th>{med.alertDate}</th>
                                    <th>
                                      <RxCross2 onClick={() => del(index)} />
                                    </th>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className='col-6 mt-3'>
                            <label htmlFor=''>Total Quantity</label>
                            <input
                              type='number'
                              className='form-control'
                              value={totqty || 0}
                            />
                          </div>
                          <div className='col-6 mt-3'>
                            <label htmlFor=''>Total Price</label>
                            <input
                              type='number'
                              className='form-control'
                              value={totprice || 0}
                            />
                          </div>

                          {branch ? (
                            <Button className='mt-4' onClick={save}>
                              Save
                            </Button>
                          ) : (
                            <Button
                              className='mt-4'
                              onClick={handleBranchError}
                            >
                              Save
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-3'>
                  <div className='card'>
                    <div className='card-body'>
                      <div className='p-2'>
                        <div class='row form-group'>
                          <label htmlFor=''> Products</label>
                          <select
                            class='custom-select border-info'
                            name='account_type_id'
                            id='cat'
                            onChange={(e) => chgItem(e.target.value)}
                          >
                            <option hidden>Choose</option>
                            {medicineLists[0] &&
                              medicineLists.map((option) => (
                                <option value={option._id}>
                                  {option.name}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div class='row form-group mt-3'>
                          <label
                            htmlFor=''
                            className={units.length === 0 && "text-danger"}
                          >
                            Item
                          </label>
                          <select
                            name=''
                            id=''
                            onChange={(e) => chgQty(e.target.value)}
                            className='form-control'
                          >
                            <option hidden>Choose Item</option>
                            {units.map((unit, i) => (
                              <option value={unit._id}>
                                {unit.medicineItemName}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div class='row form-group mt-3'>
                          <label
                            htmlFor=''
                            className={qty === 0 && "text-danger"}
                          >
                            Quantity
                          </label>
                          <input
                            type='number'
                            className='form-control'
                            defaultValue={0}
                            onChange={(e) => {
                              setQty(e.target.value);
                              handleTotalUnit(e.target.value);
                            }}
                          />
                        </div>
                        <div class='row form-group mt-3'>
                          <label htmlFor=''>Purchase Type</label>
                          <select
                            name=''
                            id=''
                            onChange={(e) => setType(e.target.value)}
                            className='form-control ml-2'
                          >
                            <option hidden>Choose Type</option>

                            <option value='Direct'>Direct</option>
                            <option value='Convert'>Convert</option>
                          </select>
                        </div>
                        {type !== "Convert" && (
                          <div class='row form-group mt-3'>
                            <label
                              htmlFor=''
                              className={!relatedUnitID && "text-danger"}
                            >
                              Unit
                            </label>
                            <select
                              name=''
                              id=''
                              onChange={(e) => chgPrice(e.target.value)}
                              className='form-control ml-2'
                            >
                              <option>Choose Unit</option>
                              {unit[0] &&
                                unit.map((u, i) => (
                                  <option value={u._id}>{u.unitName}</option>
                                ))}
                            </select>
                          </div>
                        )}
                        {type === "Convert" && (
                          <>
                            <div
                              for='name'
                              className={!toUnit && "text-danger"}
                            >
                              Unit Convention (Optional)
                            </div>
                            <div className='row'>
                              <div class='form-group col-6'>
                                <label
                                  for='name'
                                  // className={!toUnit && "text-danger"}
                                >
                                  From Unit Name
                                </label>

                                <select
                                  name=''
                                  id=''
                                  onChange={(e) =>
                                    setRelatedFromUnitName(e.target.value)
                                  }
                                  className='form-control'
                                >
                                  <option hidden>Choose</option>
                                  {unitConventionLists[0] &&
                                    unitConventionLists.map((u, i) => (
                                      <option value={u?.relatedFromUnit?._id}>
                                        {u?.relatedFromUnit?.unitName ||
                                          "not set"}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div class='form-group col-6'>
                                <label for='name'>To Unit Name</label>
                                <select
                                  name=''
                                  id=''
                                  onChange={(e) => handleToUnit(e.target.value)}
                                  className='form-control'
                                >
                                  <option hidden>Choose</option>
                                  {unitConventionLists[0] &&
                                    unitConventionLists.map((u, i) => (
                                      <option value={u._id}>
                                        {u?.relatedToUnit?.unitName ||
                                          "not set"}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>

                            <div className='row'>
                              <div className='col-md-6'>
                                <label>From Unit Convert Qty</label>
                                <input
                                  type='number'
                                  class='form-control border-info'
                                  name='balance'
                                  id='from'
                                  placeholder='From'
                                  value={1}
                                  disabled
                                  onChange={(e) =>
                                    setFromUnit(e.target.value || 1)
                                  }
                                />
                              </div>
                              <div className='col-md-6'>
                                <label className={!toUnit && "text-danger"}>
                                  To Unit Equivalent Qty
                                </label>
                                <input
                                  type='number'
                                  class='form-control border-info'
                                  name='balance'
                                  id='to'
                                  placeholder='To'
                                  disabled={type === "Direct"}
                                  value={type === "Direct" ? 1 : toUnit}
                                  onChange={(e) =>
                                    handleUnitCalculation(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                            <div class='form-group'>
                              <label for='name' className='text-secondary'>
                                Total Unit
                              </label>
                              {console.log(totalUnit, "total")}
                              <input
                                type='number'
                                class='form-control border-info'
                                name='balance'
                                id='total'
                                //   ref={(el) => (this.name = el)}
                                value={parseInt(totalUnit)}
                              />
                            </div>
                          </>
                        )}

                        <div class='row form-group mt-3'>
                          <label htmlFor=''>Expired Date</label>
                          <input
                            type='date'
                            className='form-control'
                            onChange={(e) => setExpDate(e.target.value)}
                          />
                        </div>
                        <div class='row form-group mt-3'>
                          <label htmlFor=''>Alert Date</label>
                          <input
                            type='date'
                            className='form-control'
                            onChange={(e) => setAlertDate(e.target.value)}
                          />
                        </div>
                        <div
                          class='row form-group mt-3'
                          // style={{ aspectRatio: "1", width: "100px" }}
                        >
                          <label htmlFor=''>Enter Last Purchase Price</label>
                          <div className='col-8'>
                            <input
                              type='number'
                              className='form-control'
                              value={purchasePrice}
                              onChange={(e) => setPurchasePrice(e.target.value)}
                            />
                          </div>
                          <div className='col-3 ml-2'>
                            {console.log(originalPrice, "pur")}
                            {console.log(parseInt(purchasePrice), "pur")}
                            <button
                              className='btn btn-primary'
                              style={{ marginTop: "6px" }}
                              onClick={handlePriceChange}
                              disabled={
                                originalPrice === parseInt(purchasePrice)
                              }
                            >
                              Change
                            </button>
                          </div>
                        </div>
                        {qty !== 0 &&
                        toUnit !== 0 &&
                        (relatedUnitID || relatedToUnitName) &&
                        units.length !== 0 ? (
                          <div className='row text-center mt-4'>
                            <Button onClick={addPurchase}>Add</Button>
                          </div>
                        ) : (
                          <div className='row text-center mt-4'>
                            <DisableButton className='opacity-35 p-2'>
                              Add
                            </DisableButton>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* <!-- /.content-wrapper --> */}
        <footer className='main-footer'>
          <strong>
            Copyright &copy; 2017-2020{" "}
            <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
          </strong>
          All rights reserved.
        </footer>

        {/* <!-- Control Sidebar --> */}
        <aside classNameName='control-sidebar control-sidebar-dark'>
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
};

export default Create;
